<template>
  <v-container>
    <v-layout row wrap align-top>
        <v-flex xs12 sm6 class="pa-2">
          <h2 class="display-1 section-title">About Us</h2>
          <p class="body-1">
            Lisa Hanson, founder and instructor of Viking Martial Arts is a second degree black belt in Taekwon-Do. Lisa has been an instructor for {{yearsTeaching}} years and has a BA in Special Education.
            <br />
            <br />
            Lisa has blended her two passions of martial arts and her years of teaching experience into a comprehensive program that highlights each students’ unique abilities. Her goal is to provide each student the opportunity to reach their potential by exploring a martial art and all it has to offer.
          </p>
        </v-flex>
        <v-flex xs12 sm6>
            <v-img
                :src="require('../assets/1936.jpg')"
                class="elevation-10"
                max-height="400"
                max-width="300">
            </v-img>
        </v-flex>
        <v-flex xs12 class="pa-2" order-sm2 order-xs1>
          <h2 class="display-1 section-title">Our Mission</h2>
          <p class="body-1">
            Our mission at Viking Martial Arts is to empower and provide students of all abilities with the benefits of martial arts. We strive to teach the tenants of Taekwon-Do: courtesy, integrity, perseverance, self-control, and indomitable spirit.
          </p>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2" order-sm2 order-xs1>
          <h2 class="display-1 section-title">New Location!</h2>
          <p class="body-1">
            All Classes will be held at TILT Crossfit 60 Union Ave. Sudbury
          </p>
          <h3><a href="https://maps.app.goo.gl/VzKbDnBTE7H9QAR69">Directions</a></h3>

        </v-flex>


        <v-flex xs12 sm6 class="pa-2 " order-sm2 order-xs1>
          <h2 class="display-1 section-title">Why Viking?</h2>
          <p class="body-1">
            Viking Martial Arts was named in honor of Miss Lisa’s father, Weldon Johnson. Weldon was the owner of Viking Office Supply, a store that gave back to its community. Weldon, although never a martial artist himself, lived by all the tenants of Taekwon-Do and was a real community leader.  He was known as “The Viking” to the community and could be seen wearing his full Viking costume at many events and parades.
          </p>
        </v-flex>
        <v-flex xs12 sm6 class="pa-4 text-center" order-xs3>
          <div class="text-xs-center">
            <v-img
              :src="require('../assets/Weldon.jpg')"
              class="elevation-10 centeredPic"
              max-height="400"
              max-width="300"
            ></v-img>
          </div>
        </v-flex>
    </v-layout>

  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        startYear: 2007,
        currentYear: new Date().getFullYear()
      }
    },
    computed: {
      size () {
        const binding = {}
        if (this.$vuetify.breakpoint.xsOnly) binding.column = true
        return binding
      },
      yearsTeaching () {
        return this.currentYear - this.startYear
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/about.vue